import * as types from '../types';

type TaskData = {
  taskId: string;
  quoteNumber: number;
  quoteRevision: number;
};
export const addExcelExportTasks = ({ tasks }: { tasks: TaskData[] }) => ({
  type: types.ADD_EXCEL_EXPORT_TASKS,
  payload: { tasks },
});
export const removeExcelExportTasks = ({ taskIds }: { taskIds: string[] }) => ({
  type: types.REMOVE_EXCEL_EXPORT_TASKS,
  payload: { taskIds },
});
